import React from 'react';
import useMatchMedia from '../hooks/useMatchMedia';
import { Link } from 'react-router-dom';
import './Footer.css';
import facebookIcon from '../Images/facebook.svg';
import linkedinIcon from '../Images/linkedin.svg';
import instagramIcon from '../Images/instagram.svg';
import heartIcon from '../Images/heart.svg';
import { useLanguage } from '../contexts/LanguageContext';

function Footer() {
  const { language, t } = useLanguage();
  // Evaluate media query at top-level (hooks must be called unconditionally)
  const isMobile = useMatchMedia('(max-width: 767px)');

  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-top">
          <p className="footer-copyright">{t('footer.copyright')}</p>
          <div className="footer-links">
            <Link to={`/${language}/mentions-legales`} className="footer-link">{t('footer.legalLinks.mentions')}</Link>
            <span className="footer-separator">·</span>
            <Link to={`/${language}/politique-confidentialite`} className="footer-link">{t('footer.legalLinks.privacy')}</Link>
            <span className="footer-separator">·</span>
            <Link to={`/${language}/cgv`} className="footer-link">{t('footer.legalLinks.cgv')}</Link>
          </div>
        </div>

        <div className="footer-tagline">
          {/* Render split tagline for German to insert a mobile <br/> and place the heart image as a React element.
              For other languages keep the single-string tagline. */}
          <p>
            {t('footer.tagline.part1')}
            {isMobile && <br />}
            {' '}
            {t('footer.tagline.part2')}
            <img src={heartIcon} alt="♥" className="heart-icon" />
          </p>
        </div>

        <div className="footer-social">
          <span className="social-label">{t('footer.social')}</span>
          <div className="social-icons">
            <a href="https://www.facebook.com/profile.php?id=61586900165934" target="_blank" rel="noopener noreferrer" className="social-icon">
              <img src={facebookIcon} alt="Facebook" />
            </a>
            <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="social-icon">
              <img src={linkedinIcon} alt="LinkedIn" />
            </a>
            <a href="https://www.instagram.com/grenzexpert" target="_blank" rel="noopener noreferrer" className="social-icon">
              <img src={instagramIcon} alt="Instagram" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
